var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({ backgroundColor: _vm.color, width: _vm.size, height: _vm.size, borderRadius: '50%',border: _vm.color === '#FFFFFF' ? '1px solid #000000' : 'none'})}),_c('p',[_vm._v(_vm._s(_vm.color))])])
}
var staticRenderFns = []

export { render, staticRenderFns }